import { computed } from 'vue';
import { useTokenPayload } from '@/queries/auth/use-login';
import { isExternalDriverTokenPayload } from '@/entities/auth/jwt-user.entity';

/** The External driver session, when the handover is run from an External handover link. */
export function useExternalDriver() {
  const { data: tokenPayload } = useTokenPayload();
  const externalDriver = computed(() =>
    isExternalDriverTokenPayload(tokenPayload.value) ? tokenPayload.value : null,
  );
  const isExternalDriver = computed(() => !!externalDriver.value);
  return { externalDriver, isExternalDriver };
}
